/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_DescriptionInputs */

const en_to_yaml_description = /** @type {(inputs: To_Yaml_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert JSON to YAML format online. Transform your JSON data to clean YAML syntax.`)
};

const ko_to_yaml_description = /** @type {(inputs: To_Yaml_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON을 YAML 형식으로 온라인 변환하세요. JSON 데이터를 깔끔한 YAML 구문으로 변환합니다.`)
};

const ja_to_yaml_description = /** @type {(inputs: To_Yaml_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONをYAML形式にオンライン変換。JSONデータをきれいなYAML構文に変換します。`)
};

/**
* | output |
* | --- |
* | "Convert JSON to YAML format online. Transform your JSON data to clean YAML syntax." |
*
* @param {To_Yaml_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_description = /** @type {((inputs?: To_Yaml_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_description(inputs)
	if (locale === "ko") return ko_to_yaml_description(inputs)
	return ja_to_yaml_description(inputs)
});